export default __webpack_public_path__ + "static/media/caret.11cf7352.svg";